module.exports = __webpack_public_path__ + "static/media/icon-16.0d0da0e0.png";